import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../features/appSlice/appSlice";
import consentReducer from "../features/consentSlice/consentSlice";
import templateSectionReducer from "../features/templateSectionSlice/templateSectionSlice";
import bookingReducer from "../features/templateSectionSlice/bookingSlice/bookingSlice";
export const store = configureStore({
  reducer: {
    app: appReducer,
    consent: consentReducer,
    templateSection: templateSectionReducer,
    bookingSection: bookingReducer,
  },
});
export const { dispatch } = store;
